module.exports = __webpack_public_path__ + "static/media/logo-receita.6d856460.svg";